import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  dateForList,
  dateForListWithHours,
} from "../../../../constants/dataFormat";
import {
  CNPJFormater,
  CPFFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import InfoCardsDetalhamento from "../../boletos/defaultComponents/InfoCardsDetalhamento";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

interface objetoBatchList {
  idLote: string;
  idCliente: number;
  dataCriacao: string;
  status: string;
  valor: number;
  diaVencimento: number;
  parcelas: number;
  mesesPular: number;
  descricao: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  isAtivo: boolean;
  RegrasJuros?: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
  RegrasMulta?: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
}

interface ModalDetailVendaBoletoLoteProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  item: objetoBatchList | {};
}

export default function ModalDetailVendaBoletoLote({
  isOpen,
  setIsOpen,
  item,
}: ModalDetailVendaBoletoLoteProps) {
  const [colors] = useRecoilState(customColors);
  const [objetoPagamento, setObjetoPagamento] = useState<
    { titulo: string; valor: string }[]
  >([]);
  const [objetoBeneficiario, setObjetoBeneficiario] = useState<
    { titulo: string; valor: string }[]
  >([]);
  const [objetoFixo, setObjetoFixo] = useState<
    { titulo: string; valor: string }[]
  >([
    {
      titulo: "CPF/CNPJ do Beneficiário",
      valor: "19.468.242/0001-32",
    },
    { titulo: "Razão Social", valor: "IFOOD PAGO INSTITUICAO DE PAGAMENTO S.A." },
  ]);

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      const batch = item as objetoBatchList;

      const gerarObjetoPagamento = () => [
        {
          titulo: "Status",
          valor: batch.isAtivo ? "Ativo" : "Cancelado",
        },
        {
          titulo: "Data de Criação",
          valor: batch.dataCriacao
            ? moment(batch.dataCriacao).format(dateForListWithHours)
            : "N/A",
        },
        {
          titulo: "Dia de Vencimento",
          valor: batch.diaVencimento ? `Dia ${batch.diaVencimento}` : "N/A",
        },
        {
          titulo: "Valor Total",
          valor: ToLocaleFormat(batch.valor) || "R$ 0,00",
        },
        {
          titulo: "Quantidade de Parcelas",
          valor: batch.parcelas.toString() || "0",
        },
        {
          titulo: "Meses a Pular",
          valor:
            batch.mesesPular === -1
              ? "Segunda parcela no mesmo mês"
              : batch.mesesPular.toString(),
        },
        {
          titulo: "Descrição Base",
          valor: batch.descricao || "N/A",
        },
      ];

      const gerarObjetoBeneficiario = () => {
        const cnpjOrCpf = batch.cpfPagador
          ? batch.cpfPagador.length === 11
            ? CPFFormater(batch.cpfPagador)
            : CNPJFormater(batch.cpfPagador)
          : "N/A";

        return [
          {
            titulo: "CPF/CNPJ do Pagador",
            valor: cnpjOrCpf,
          },
          {
            titulo: "Nome do Pagador",
            valor: batch.nomePagador || "N/A",
          },
          {
            titulo: "E-mail do Pagador",
            valor: batch.emailPagador || "N/A",
          },
          {
            titulo: "Endereço",
            valor: `${batch.enderRua}, ${batch.enderNumero}, ${batch.enderBairro}, ${batch.enderCidade} - ${batch.enderEstado}, CEP: ${batch.enderCEP}`,
          },
          {
            titulo: "Complemento",
            valor: batch.enderComplemento || "N/A",
          },
          {
            titulo: "Referência",
            valor: batch.enderReferencia || "N/A",
          },
        ];
      };

      setObjetoPagamento(gerarObjetoPagamento());
      setObjetoBeneficiario(gerarObjetoBeneficiario());
    } else {
      setObjetoPagamento([]);
      setObjetoBeneficiario([]);
    }
  }, [item]);

  const onClose = () => setIsOpen(false);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />
      <ModalContent
        borderRadius="lg"
        boxShadow="lg"
        bg="white"
        p={4}
        maxHeight="80vh"
      >
        <ModalHeader
          textAlign="center"
          fontSize="xl"
          fontWeight="semibold"
          color="gray.800"
        >
          Detalhes do Lote de Boletos
        </ModalHeader>
        {item && Object.keys(item).length !== 0 ? (
          <ModalBody overflowY="auto" maxHeight="60vh">
            <VStack spacing={6} align="stretch">
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações do Pagamento"
                  array={objetoPagamento}
                />
              </Box>
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações do Pagador"
                  array={objetoBeneficiario}
                />
              </Box>
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações Fixas"
                  array={objetoFixo}
                />
              </Box>
            </VStack>
          </ModalBody>
        ) : (
          <ModalBody overflowY="auto" maxHeight="60vh">
            <Text textAlign="center" color="gray.500">
              Nenhuma informação disponível
            </Text>
          </ModalBody>
        )}
        <ModalFooter justifyContent="center" gap={4}>
          <Button
            bg="gray.500"
            color="white"
            px={6}
            borderRadius="md"
            _hover={{ bg: "gray.600" }}
            onClick={onClose}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
